import React, { useState, useEffect } from "react";
import "../components/Table/Table.css";
import { useTranslation } from "react-i18next";

const ApplyStudentLeave = () => {
    const { t } = useTranslation();
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [leaveDuration, setLeaveDuration] = useState("");

    useEffect(() => {
        if (fromDate && toDate) {
            const from = new Date(fromDate);
            const to = new Date(toDate);
            const duration = (to - from) / (1000 * 60 * 60 * 24) + 1;
            if (duration >= 0) {
                setLeaveDuration(duration + " days");
            } else {
                setLeaveDuration("");
            }
        } else {
            setLeaveDuration("0");
        }
    }, [fromDate, toDate]);

    return (
        <>
            <div className="px-2 px-md-4">
                <div className="my-4 col-12 d-flex justify-content-between align-items-center">
                    <h5 className="">{t("Apply Student Leave")}</h5>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Academic year")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="academic_year"
                            className="common-input form-select"
                            required
                        >
                            <option value="">Select session</option>
                            <option value="">2022-2024</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Class Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="class"
                            className="common-input form-select"
                        >
                            <option value="">Select class</option>
                            <option value="12">12</option>
                            <option value="11">11</option>
                            <option value="10">10</option>
                            <option value="09">09</option>
                            <option value="08">08</option>
                            <option value="07">07</option>
                            <option value="06">06</option>
                            <option value="05">05</option>
                            <option value="04">04</option>
                            <option value="03">03</option>
                            <option value="02">02</option>
                            <option value="01">01</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Section Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="section"
                            className="common-input form-select"
                        >
                            <option value="">Select section</option>
                            <option value="">A</option>
                            <option value="">B</option>
                            <option value="">C</option>
                        </select>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Student Name")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="student_name"
                            className="common-input form-select"
                        >
                            <option value="">Select student</option>
                            <option value="">Abhay</option>
                            <option value="">Bindra</option>
                            <option value="">Chaman</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Leave Type")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="leave_type"
                            className="common-input form-select"
                        >
                            <option value="">Select leave type</option>
                            <option value="">Casual Leave</option>
                            <option value="">Medical Leave</option>
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("Leave Day Type")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <select
                            name="leave_day_type"
                            className="common-input form-select"
                        >
                            <option value="">Select day type</option>
                            <option value="">Full Day</option>
                            <option value="">Half Day</option>
                        </select>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("From Date")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input style={{ width: "28rem" }}
                            type="date"
                            name="fromDate"
                            className="form-control"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="form-label">
                            {t("To Date")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input style={{ width: "28rem" }}
                            type="date"
                            name="toDate"
                            className="form-control"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            required
                        />
                    </div>
                    <div className="col-md-4">
                        <label className="from-label">
                            {t("Leave Duration")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <input style={{ width: "28rem" }}
                            name="leave_duration"
                            className="form-control mt-2"
                            value={leaveDuration}
                            required
                            readOnly
                        />
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-4">
                        <label className="from-label">
                            {t("Comment")}
                            {<span style={{ color: "red" }}>*</span>}
                        </label>
                        <textarea
                            className="form-control"
                            rows="2"
                        >
                        </textarea>
                    </div>
                </div>

                <div className="row col-6 mt-5 d-flex mx-1">
                    <button type="submit"
                        className="btn btn-primary me-2 col-md-2"
                    >
                        {t("Apply")}
                    </button>

                    <button
                        type="submit"
                        className="btn btn-secondary me-2 col-md-2"
                    >
                        {t("Cancel")}
                    </button>
                </div>
            </div>
        </>
    );
};

export default ApplyStudentLeave;